import { isObject } from 'underscore';
const pruneTree = content => {
  Object.keys(content).forEach(key => {
    if (isObject(content[key])) {
      if (Object.keys(content[key]).length > 0) {
        // eslint-disable-next-line no-param-reassign
        content[key] = pruneTree(content[key]); // follow the tree
      }
      // @NOTE do not use `else if` here, otherwise a recursively pruned object (from above
      // `pruneTree`) will not get a chance at being deleted. it is also necesarry to recount the
      // length of Object.keys as it may have changed after the above `pruneTree` call.
      if (Object.keys(content[key]).length === 0) {
        // eslint-disable-next-line no-param-reassign
        delete content[key]; // prune empty leaves
      }
    }
  });
  return content;
};
const _removeNulls = function removeNulls() {
  let content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (content === null || content === 'undefined') {
    return {};
  }
  Object.keys(content).forEach(prop => {
    if (content[prop] === null) {
      // eslint-disable-next-line no-param-reassign
      delete content[prop];
      // We do not have to do additional null checking here since
      // we've already checked for null
    } else if (typeof content[prop] === 'object') {
      // eslint-disable-next-line no-param-reassign
      content[prop] = _removeNulls(content[prop]);
    }
  });
  return content;
};
const applyNullRemove = content => pruneTree(_removeNulls(content));
export { applyNullRemove, _removeNulls as removeNulls, pruneTree };